import { render, staticRenderFns } from "./batchCheck.vue?vue&type=template&id=61f1b98a&scoped=true"
import script from "./batchCheck.vue?vue&type=script&lang=js"
export * from "./batchCheck.vue?vue&type=script&lang=js"
import style0 from "./batchCheck.vue?vue&type=style&index=0&id=61f1b98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f1b98a",
  null
  
)

export default component.exports